module.exports = __webpack_public_path__ + "img/bulk-def.2a1e8d65.svg";